<template>
  <section class="main">
    <nut-avatar size="40" bg-color="#effafa">
      <img src="../../assets/images/logo.png"/>
    </nut-avatar>
    <h1 class="main-title">玉麒麟账密管理平台-登录</h1>
    <nut-form :rules="rules" :model-value="formData" ref="formRef">
      <nut-form-item prop="account" label-width=".73rem">
        <template #label>
          <span class="iconfont icon-user" />
        </template>
        <template #default>
          <nut-input v-model="formData.account" placeholder="请输入账号" clearable :border="false"  max-length="11" />
        </template>
      </nut-form-item>
      <nut-form-item prop="password" label-width=".73rem">
        <template #label>
          <span class="iconfont icon-password" />
        </template>
        <template #default>
          <nut-input v-model="formData.password" type="password" placeholder="请输入密码" clearable :border="false"  max-length="16" />
        </template>
      </nut-form-item>
    </nut-form>
    <article class="main-tip">
      <p>没有账号？<router-link to="/register">去注册</router-link></p>
    </article>
    <article class="main-operate">
      <nut-button type="primary" shape="square" block @click="submit" :loading="loading">登录</nut-button>
    </article>
  </section>
</template>
<script setup lang="ts">
const router = useRouter();
const loading = ref(false);
const formRef = ref(null);
const formData = reactive({
  account: '',
  password: ''
});

const rules = { 
  account: [
    { required: true, message: '请输入账号'},
    { regex: /^1\d{10}$/, message: '请输入正确的手机号' },
  ],
  password: [
    { required: true, message: '请输入密码'},
  ]
};

const submit = () => {
  // @ts-ignore
  formRef.value.validate().then(({ valid, errors }) => {
    if (!valid) {
      return showToast.text(errors[0].message);
    }
    // 校验成功，下一步
    loading.value = true;
    request<"user">("user", "login", {
      username: formData.account,
      password: formData.password
    }).then(res => {
      localStorage.setItem('token', res.data);
      router.push('/');
    }).finally(() => loading.value = false);
  })
}

</script>
<style lang='scss' scoped>
.main{
  min-height: 100vh;
  background-color: #effafa;
  text-align: center;
  box-sizing: border-box;
  padding: 80px 20px 0;
  &-title{
    font-size: 22px;
    color: #1c9c69;
    margin: 20px 0 80px;
    font-weight: bold;
  }
  &-tip{
    font-size: 12px;
    color: #333;
  }
  &-operate{
    box-sizing: border-box;
    width: 100%;
    padding: 0 20px;
    position: fixed;
    bottom: 20px;
    left: 0;
  }
}
</style>